import type {
  GetSignParams,
  GetSignRes,
  GetRegisterStatusParams,
  GetRegisterStatusRes,
  GetRegisterParams,
  GetRegisterRes,
  GetBindingParams,
  GetBindingRes,
} from '@/types/user';
import { get, post } from '@web3/base-utils';

export const getSign = (data: GetSignParams) => {
  return post<GetSignRes>('/spot/api/web3/content/wsot/prepare', data);
};

export const getRegisterStatus = (data: GetRegisterStatusParams) => {
  return get<GetRegisterStatusRes>(
    '/spot/api/web3/content/wsot/registerStatus',
    data
  );
  // return Promise.resolve({
  //   success: true,
  //   result: {
  //     registerStatus: 1,
  //     bindID: '',
  //   },
  // });
};

export const getRegister = (data: GetRegisterParams) => {
  return post<GetRegisterRes>('/spot/api/web3/content/wsot/register ', data);
};

export const getBinding = (data: GetBindingParams) => {
  return post<GetBindingRes>('/spot/api/web3/content/wsot/binding', data);
};
